export default "__VITE_ASSET__BYK6IQ5T__"